<agr-wrapper-site-sidenav data-test="site-root">
  <router-outlet></router-outlet>
</agr-wrapper-site-sidenav>
